import { DataGridProps, GridSortModel } from "@mui/x-data-grid";
import { useState } from "react";

type GridSortItem = GridSortModel[number];

interface UsePaginationSortDataGridProps {
  pageSize?: number;
  defaultSortModel: GridSortItem;
  serverColumnMappingSort?: Record<string, string>;
  mode?: "client" | "server";
}

export const usePaginationSortDataGrid = ({
  pageSize = 30,
  defaultSortModel,
  serverColumnMappingSort,
  mode = "client",
}: UsePaginationSortDataGridProps) => {
  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSize,
    page: 0,
  });

  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: defaultSortModel?.field as string,
      sort: defaultSortModel?.sort as "asc" | "desc",
    },
  ]);

  const paginationProps: Partial<DataGridProps> & {
    autoCacheRowCount?: boolean;
  } =
    mode === "server"
      ? {
          paginationModel,
          onPaginationModelChange: setPaginationModel,
          // Set pageSizeOptions to hide text "Rows per page"
          pageSizeOptions: [pageSize],
          paginationMode: "server",
          hideFooter: false,
        }
      : {
          paginationMode: mode,
          onPaginationModelChange: setPaginationModel,
          hideFooter: false,
          autoCacheRowCount: false,
          pageSizeOptions: [pageSize, 50, 100],
          initialState: {
            pagination: {
              paginationModel: {
                pageSize: pageSize,
              },
            },
          },
        };

  const serverPagination = {
    limit: paginationModel.pageSize,
    offset: paginationModel.page * paginationModel.pageSize,
  };

  const sortChange = (sortModel: GridSortModel) => {
    const currentField = sortModel?.[0]?.field;
    const serverField = serverColumnMappingSort?.[currentField];
    setSortModel(
      sortModel.map((item) => ({
        field: serverField as string,
        sort: item.sort,
      })),
    );
  };

  const sortProps: Partial<DataGridProps> = {
    sortModel,
    onSortModelChange: mode === "server" ? sortChange : setSortModel,
    sortingMode: mode,
    // only accept 'asc' or 'desc' for sorting, https://mui.com/x/react-data-grid/sorting/?srsltid=AfmBOor_jDDoWcfV1wvpJbpi1e9jCdSz8sdt8QqDnCkrHBXwqcaIOoZh#custom-sort-order
    sortingOrder: ["desc", "asc"],
  };

  return {
    paginationProps,
    serverPagination,
    sortProps,
  };
};
